module.exports = __webpack_public_path__ + "static/media/NOVATEC-rgb-weiss-cyan-tuerkis_schutz.05ed30e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NOVATEC-rgb-weiss-cyan-tuerkis_schutz.png
// module id = 221
// module chunks = 8